/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Reply_PlaceholderInputs */

const cs_messages_reply_placeholder = /** @type {(inputs: Messages_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napište odpověď…`)
};

const en_messages_reply_placeholder = /** @type {(inputs: Messages_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a reply…`)
};

/**
* | output |
* | --- |
* | "Write a reply…" |
*
* @param {Messages_Reply_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_reply_placeholder = /** @type {((inputs?: Messages_Reply_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Reply_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_reply_placeholder(inputs)
	return cs_messages_reply_placeholder(inputs)
});